// extracted by mini-css-extract-plugin
export default {"Page":"Index-module__Page__gEeIxTB","Section":"Index-module__Section__iyAJPGi","Container":"Index-module__Container__j4vMEuA","Component":"Index-module__Component__TjroKnt"};